document.addEventListener('DOMContentLoaded', function() {
  if (document.getElementById('mossen-top-loader')) return;

  // 1. Création des éléments (Barre + Cercle + Voile blanc)
  const loaderLine = document.createElement('div');
  loaderLine.id = 'mossen-top-loader';
  document.body.appendChild(loaderLine);

  const loaderCircle = document.createElement('div');
  loaderCircle.id = 'mossen-mobile-spinner';
  document.body.appendChild(loaderCircle);

  const loaderOverlay = document.createElement('div');
  loaderOverlay.id = 'mossen-loading-overlay';
  document.body.appendChild(loaderOverlay);

  // 2. Injection du style global (Bleu, Correction de couche mobile & Voile Blanc)
  const style = document.createElement('style');
  style.textContent = `
    /* --- COUCHE 1 : LE VOILE BLANC D'OPACITÉ --- */
    #mossen-loading-overlay {
      position: fixed !important;
      inset: 0 !important;
      background: rgba(255, 255, 255, 0.45) !important;
      z-index: 2147483646 !important;
      pointer-events: none !important;
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.25s ease, visibility 0.25s ease;
    }
    #mossen-loading-overlay.mossen-is-loading {
      opacity: 1 !important;
      visibility: visible !important;
      pointer-events: auto !important;
    }

    /* --- COUCHE 2 : LA BARRE DE CHARGEMENT BLEUE --- */
    #mossen-top-loader {
      position: fixed !important;
      top: 0 !important;
      left: 0 !important;
      width: 100vw !important;
      height: 3px !important; /* Épaisseur fine de 3px */
      z-index: 2147483647 !important;
      background: transparent !important;
      overflow: hidden !important;
      pointer-events: none !important;
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.2s ease, visibility 0.2s ease;
      transform: translateZ(0) !important; /* Active le GPU du téléphone */
    }
    #mossen-top-loader.mossen-is-loading {
      opacity: 1 !important;
      visibility: visible !important;
    }

    /* Le trait bleu qui démarre toujours à gauche */
    #mossen-top-loader::before {
      content: "" !important;
      position: absolute !important;
      top: 0 !important;
      left: 0 !important; /* Fixé à 0 pour forcer iOS à peindre l'élément */
      height: 100% !important;
      width: 35% !important;
      background: #0052cc !important; /* Bleu royal */
      animation: mossenLeftToRight 0.8s infinite linear !important;
    }

    /* --- COUCHE 3 : LE CERCLE TOURNANT BLEU (Mobile uniquement) --- */
    #mossen-mobile-spinner {
      display: none;
      position: fixed !important;
      top: 18px !important;
      right: 18px !important;
      width: 20px !important;
      height: 20px !important;
      border: 2px solid rgba(0, 82, 204, 0.15) !important;
      border-top-color: #0052cc !important;
      border-radius: 50% !important;
      z-index: 2147483647 !important;
      pointer-events: none !important;
      opacity: 0;
      visibility: hidden;
      transition: opacity 0.2s ease, visibility 0.2s ease;
      transform: translateZ(0) !important;
    }
    @media screen and (max-width: 749px) {
      #mossen-mobile-spinner { display: block; }
    }
    #mossen-mobile-spinner.mossen-is-loading {
      opacity: 1 !important;
      visibility: visible !important;
      animation: mossenSpin 0.8s linear infinite !important;
    }

    /* --- ANIMATIONS CORRIGÉES CONTRE LES BUGS DE RENDU MOBILE --- */
    @keyframes mossenLeftToRight {
      0% { transform: translateX(-100%); } /* Démarre à l'extrême gauche, juste hors-écran */
      100% { transform: translateX(100vw); } /* Traverse et sort à l'extrême droite */
    }
    @keyframes mossenSpin {
      to { transform: rotate(360deg) translateZ(0); }
    }
  `;
  document.head.appendChild(style);

  // 3. Logique d'activation synchronisée
  function showLoader() {
    const line = document.getElementById('mossen-top-loader');
    const circle = document.getElementById('mossen-mobile-spinner');
    const overlay = document.getElementById('mossen-loading-overlay');
    
    if (line) line.classList.add('mossen-is-loading');
    if (circle) circle.classList.add('mossen-is-loading');
    if (overlay) overlay.classList.add('mossen-is-loading');

    setTimeout(hideLoader, 10000);
  }

  function hideLoader() {
    const line = document.getElementById('mossen-top-loader');
    const circle = document.getElementById('mossen-mobile-spinner');
    const overlay = document.getElementById('mossen-loading-overlay');
    
    if (line) line.classList.remove('mossen-is-loading');
    if (circle) circle.classList.remove('mossen-is-loading');
    if (overlay) overlay.classList.remove('mossen-is-loading');
  }

  // 4. Écouteurs de navigation (Liens)
  document.addEventListener('click', function(e) {
    const link = e.target.closest('a');
    if (!link) return;
    const href = link.getAttribute('href');
    if (!href) return;

    const isInternal = (href.startsWith('/') && !href.startsWith('//')) || href.startsWith(window.location.origin);
    const isNotHash = !href.startsWith('#');
    const isNotNewTab = link.target !== '_blank';
    const isNotAction = !href.startsWith('mailto:') && !href.startsWith('tel:') && !href.includes('javascript:');

    if (isInternal && isNotHash && isNotNewTab && isNotAction) {
      showLoader();
    }
  });

  // 5. Écouteurs de soumission (Formulaires)
  document.addEventListener('submit', function(e) {
    if (e.target.target !== '_blank' && !e.target.classList.contains('js-ajax-form')) {
      showLoader();
    }
  });

  // 6. Nettoyage de l'état historique cache
  window.addEventListener('pageshow', hideLoader);
  window.addEventListener('popstate', hideLoader);
});